<template>
    <div class="color-filter">
        <div class="top-controls">
            <div class="checkbox-row">
                <label>
                    <input type="checkbox"
                           v-model="requiresBoth"
                           :disabled="!bothSelected"
                           @change="emitChange" />
                    Must Have Both
                </label>

                <button v-if="color1 || color2 || requiresBoth"
                        type="button"
                        class="reset-button"
                        @click="reset">
                    Reset Colors
                </button>
            </div>
        </div>

        <!-- Select lists -->
        <div class="color-selects">
            <select v-model="color1" @change="onColorChange">
                <option :value="null">Select Color</option>
                <option v-for="item in colors"
                        :key="item.value"
                        :value="item.value"
                        :disabled="item.value === color2">
                    {{ item.value }}
                </option>
            </select>

            <select v-model="color2" @change="onColorChange">
                <option :value="null">Select Color</option>
                <option v-for="item in colors"
                        :key="item.value"
                        :value="item.value"
                        :disabled="item.value === color1">
                    {{ item.value }}
                </option>
            </select>
        </div>

    </div>
</template>

<script>
    export default {
        name: "ColorChooser",

        props: {
            colors: {
                type: Array,
                required: true,
            }
        },

        emits: ["change"],

        data() {
            return {
                color1: null,
                color2: null,
                requiresBoth: false,
            };
        },

        computed: {
            bothSelected() {
                return !!this.color1 && !!this.color2;
            }
        },

        methods: {
            onColorChange() {
                // If one color was cleared, Must Have Both is invalid
                if (!this.bothSelected) {
                    this.requiresBoth = false;
                }
                this.emitChange();
            },

            emitChange() {
                this.$emit("change", {
                    color1: this.color1,
                    color2: this.color2,
                    requiresBoth: this.requiresBoth,
                });
            },

            reset(emitChange = true) {
                this.color1 = null;
                this.color2 = null;
                this.requiresBoth = false;
                if (emitChange) {
                    this.emitChange();
                }
            },

            setColors(color1, color2 = null, requireBoth = false, emitChange = true) {
                this.color1 = color1;
                this.color2 = color2;
                this.requiresBoth = requireBoth

                if (emitChange) {
                    this.emitChange();
                }
            }
        }
    };
</script>

<style scoped>
    .color-filter {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        border-bottom: 1px solid #000;
        overflow: visible;
        padding-top: 0;
        padding-bottom: 0;
        top: -.4rem;
    }

    .top-controls {
        position: absolute;
        top: -14px; 
        right: 0;
        width: 100%;
        pointer-events: auto;
    }

    
    .checkbox-row {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 1rem;
        font-size: 0.8rem; 
    }

    .color-selects {
        display: flex;
        gap: 1rem;
    }

        .color-selects select {
            flex: 1;
            min-width: 0;
            max-width: 100%;
            border: none;
            border-bottom: none;
            background: transparent;
            font-size: 1.5rem;
            padding: 6px 24px 6px 0;
            line-height: 1.4;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

            .color-selects select:focus {
                outline: none;
            }

    .checkbox-row input[type="checkbox"] {
        margin-right: 0.4rem;
    }

    .reset-button {
        background: none;
        border: none;
        color: #0077cc;
        cursor: pointer;
        font-size: 0.8rem;
        padding: 1px 5px !important;
    }

        .reset-button:hover {
            text-decoration: underline;
        }
</style>